import { lightbox } from '../utils/lightbox.js';
import { loadCarousel } from '../utils/carousel.js';
import { faqAccordion } from '../utils/faq.js';
import sal from 'sal.js/dist/sal.js';
import 'jquery';
import '../utils/slick.js';

sal({
  threshold: 0.1
});

jQuery(function () {
  jQuery(window).on('load resize orientationchange', function () {
    var carousel = jQuery('.pricing-cards .cards');
    if (jQuery(window).width() > 768) {
      if (carousel.hasClass('slick-initialized')) {
        carousel.slick('unslick');
      }
    } else {
      if (!carousel.hasClass('slick-initialized')) {
        carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          dots: true,
          nextArrow: '<div class="slick-arrow slick-arrow-right"></div>',
          prevArrow: '<div class="slick-arrow slick-arrow-left"></div>'
        });
        var card = jQuery('.pricing-cards .cards .card-inner');
        card.removeAttr('data-sal data-sal-duration data-sal-delay');
      }
    }
  });

  $(document).ready(function () {
    // Function to show the appropriate pricing div based on country code
    function displayPricing(browserLang) {
      const pricingDiv = $('.currency');

      const currencyElements = document.querySelectorAll('.currency');
      //const currencyusElements = document.querySelectorAll('.currency-us');
      const currencydollarElements =
        document.querySelectorAll('.currency-dollar');
      const currencyeuroElements = document.querySelectorAll('.currency-euro');
      const currencypriceElements =
        document.querySelectorAll('.currency-price');
      // Check for language and region
      const langParts = browserLang.split('-');
      const primaryLang = langParts[0];
      const region = langParts[1];
      //console.log(browserLang);

      /*if (browserLang === 'en-us' || browserLang === 'en') {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.dollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = '';
        });*/
      /*currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      } else*/
      if (
        [
          'at',
          'ax',
          'be',
          'gp',
          'gf',
          'hr',
          'cy',
          'ee',
          'fi',
          'fr',
          'de',
          'gr',
          'ie',
          'ic',
          'it',
          'lv',
          'lt',
          'lu',
          'mq',
          'mt',
          'nl',
          'pt',
          're',
          'sk',
          'si',
          'es',
          'mc',
          'ad',
          'sm',
          'uk',
          'va',
          'yt'
        ].includes(primaryLang) ||
        (primaryLang === 'es' && region === 'es') ||
        (primaryLang === 'pt' && region === 'pt') ||
        (primaryLang === 'en' && region === 'ie')
      ) {
        //['fr', 'de', 'en-gb', 'it', 'nl', 'be', 'lu', 'ie', 'cz', 'pl', 'ro', 'hu', 'se', 'at', 'bg', 'dk', 'fi', 'sk', 'no', 'gr', 'hr', 'si', 'lt', 'lv', 'ee', 'cy', 'mt', 'is', 'li', 'mc', 'ad', 'sm', 'va']
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.euro;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = '';
        });*/
        currencyeuroElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = '';
        });
      } else {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.dollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      }
      /*else {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.usdollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });*/
      /*currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      }*/
    }

    // Get browser language
    //const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();

    // Determine pricing based on browser language and region
    //displayPricing(browserLang);

    async function determineLangUser() {
      let langUser;
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        langUser = data.country.toLowerCase();
      } catch (error) {
        //console.error("GeoIP lookup failed, falling back", error);
        langUser = navigator.language.toLowerCase();
      }

      //console.log('Language or Country Code:', langUser);
      displayPricing(langUser);
    }

    determineLangUser();
  });
});

/*pricing v6 */
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('annual-toggle');
  const cards = document.querySelector('.pricing-cards');
  const details = document.querySelector('.overflow');

  if (toggle) {
    const monthlyOption = toggle.querySelector('.monthly');
    const annualOption = toggle.querySelector('.annual');

    toggle.addEventListener('click', function (e) {
      if (e.target.classList.contains('monthly')) {
        monthlyOption.classList.add('active');
        annualOption.classList.remove('active');
        cards.classList.add('monthly');
        cards.classList.remove('annual');
        details.classList.add('monthly');
        details.classList.remove('annual');
      }

      if (e.target.classList.contains('annual')) {
        annualOption.classList.add('active');
        monthlyOption.classList.remove('active');
        cards.classList.add('annual');
        cards.classList.remove('monthly');
        details.classList.add('annual');
        details.classList.remove('monthly');
      }
    });
  }

  lightbox();
  loadCarousel();
  faqAccordion();
});

document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.getElementById('stickyPlans');
  const planSection = document.getElementById('planSection');
  const faqSection = document.getElementById('faqSection');

  const OFFSET = 80;
  let wasStopped = false;

  function updateSticky() {
    const scrollY = window.scrollY;
    const planTop = planSection.offsetTop;
    const stickyHeight = sticky.offsetHeight;
    const faqTop = faqSection.offsetTop;
    const faqBottom = faqTop + faqSection.offsetHeight;

    const isInStickyZone =
      scrollY + OFFSET >= planTop &&
      scrollY + stickyHeight + OFFSET < faqBottom;
    const isBelowFaq = scrollY + stickyHeight + OFFSET >= faqBottom;
    const isAbovePlan = scrollY + OFFSET < planTop;

    if (isInStickyZone) {
      sticky.classList.add('is-sticky');
      sticky.classList.remove('is-stopped');
      sticky.style.top = '';
      wasStopped = false;
    } else if (isBelowFaq) {
      sticky.classList.remove('is-sticky');
      sticky.classList.add('is-stopped');
      sticky.style.top = `${faqBottom - stickyHeight - planTop}px`;
      wasStopped = true;
    } else if (isAbovePlan) {
      sticky.classList.remove('is-sticky');
      sticky.classList.remove('is-stopped');
      sticky.style.top = '';
      wasStopped = false;
    } else {
      sticky.classList.remove('is-sticky');
      sticky.classList.remove('is-stopped');
      sticky.style.top = '';
      wasStopped = false;
    }
  }

  window.addEventListener('scroll', updateSticky);
  window.addEventListener('resize', updateSticky);
  updateSticky();
});

//popup
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.popup-trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const popupId = btn.getAttribute('aria-controls');
      const popup = document.getElementById(popupId);

      document.querySelectorAll('.popup-modal').forEach((p) => {
        if (p.id !== popupId) {
          p.setAttribute('hidden', '');
          const triggerBtn = document.querySelector(
            `button[aria-controls="${p.id}"]`
          );
          if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
        }
      });

      if (popup.hasAttribute('hidden')) {
        // open popup
        popup.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        /* popup.querySelector('.popup-close').focus(); */
      } else {
        // close  popup
        popup.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });

  /*   document.querySelectorAll('.popup-close').forEach(btn => {
    btn.addEventListener('click', () => {
      const popup = btn.closest('.popup-modal');
      popup.setAttribute('hidden', '');
      const triggerId = popup.id;
      const triggerBtn = document.querySelector(`button[aria-controls="${triggerId}"]`);
      if (triggerBtn) {
        triggerBtn.setAttribute('aria-expanded', 'false');
        triggerBtn.focus();
      }
    });
  }); */

  document.querySelectorAll('.popup-modal').forEach((popup) => {
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.setAttribute('hidden', '');
        const triggerId = popup.id;
        const triggerBtn = document.querySelector(
          `button[aria-controls="${triggerId}"]`
        );
        if (triggerBtn) {
          triggerBtn.setAttribute('aria-expanded', 'false');
          triggerBtn.focus();
        }
      }
    });
  });
});
